const PersonIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox={'0 0 28 28'}>
      <path data-name="Path 26678" d="M0 0h32.534v32.534H0z" fill="none"/>
      <path data-name="Path 26679" d="M14.845 14.845a5.422 5.422 0 1 0-5.423-5.423 5.421 5.421 0 0 0 5.423 5.423zm0 2.711C11.225 17.556 4 19.372 4 22.978v2.711h21.689v-2.711c0-3.606-7.225-5.422-10.844-5.422z" transform="translate(1.422 1.422)" fill={'currentColor'}/>
    </svg>
  );
};

export default PersonIcon;
